<template>
  <div>
    <headBox title="待结算收入明细" :showBack="true"></headBox>
    <div class="statistics">
      <topSearchForm @search="searchAjax()" :hiddenExport="false" @export="exportOut">
        <el-form :inline="true" class="rform" label-position="left">
          <el-form-item label="保单号" prop="policyNo" class="items">
            <el-input v-model="searchParams.policyNo" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName" class="items">
            <el-input v-model="searchParams.productName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="" prop="insureName" class="item">
            <el-input v-model="insureName" clearable placeholder="请输入">
              <el-select v-model="nameType" style="width: 88px" placeholder="请选择" slot="prepend">
                <el-option label="投保人" value="1"></el-option>
                <el-option label="被保人" value="2"></el-option>
              </el-select>
            </el-input>
          </el-form-item>

          <el-form-item label="承保时间" prop="createTime" class="two">
            <el-date-picker
              v-model="searchParams.createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 300px"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </topSearchForm>

      <div class="total-content">
        <div>合计</div>
        <div>
          <div class="fengexian"></div>
          <div class="sums2">{{ totalData.policyNum ? totalData.policyNum : '0.00' }}</div>
          <div>总保单数(件)</div>
        </div>
        <div>
          <div class="fengexian"></div>
          <div class="sums1">{{ totalData.feeSum ? totalData.feeSum : '0.00' }}</div>
          <div>总保费(元)</div>
        </div>
        <div>
          <div class="fengexian"></div>
          <div class="sums1">
            {{ totalData.totalIncomesSum ? totalData.totalIncomesSum : '0.00' }}
          </div>
          <div>
            总服务费(元)
          </div>
        </div>
      </div>

      <el-table :data="tableData" border class="list-table" tooltip-effect="dark" v-loading="listLoading" row-key="id">
        <el-table-column prop="policyNo" label="保单号" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.policyNo }}
          </template>
        </el-table-column>

        <el-table-column prop="mechanShortName" label="出单团队" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.mechanShortName }}
          </template>
        </el-table-column>

        <el-table-column prop="productName" label="险种名称" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.additionPolicyId" class="fijiaxian">附</span>
            {{ scope.row.productName }}
          </template>
        </el-table-column>

        <el-table-column prop="policyerName" label="投 / 被保人" min-width="140px" width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope"> {{ scope.row.policyerName }} / {{ scope.row.insuranceName }} </template>
        </el-table-column>

        <el-table-column prop="payNum" label="期数" width="100" :show-overflow-tooltip="true">
          <template slot-scope="{ row }">
            {{ row.isPostf == 1 ? '首期后置' : getPayNum(row.payNum) }}
          </template>
        </el-table-column>

        <el-table-column prop="fee" label="保费(元)" min-width="140px" width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.fee }}
          </template>
        </el-table-column>

        <el-table-column prop="commissionVal" label="基础费率 / 服务费(元)" min-width="140px" width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.commissionVal">{{ scope.row.commissionVal }}% / {{ scope.row.incomes }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column prop="subsidyCommissionVal" label="活动费率 / 服务费(元)" min-width="140px" width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.subsidyCommissionVal"
              >{{ scope.row.subsidyCommissionVal ? scope.row.subsidyCommissionVal + '%' : '-' }}/
              {{ scope.row.subsidyIncomes > 0 ? scope.row.subsidyIncomes : '-' }}</span
            >
            <span v-else>-</span>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                <div style="text-align: left">活动名称：{{ scope.row.activityName ? scope.row.activityName : '-' }}</div>
                <div style="text-align: left">
                  活动时间：{{ scope.row.activityStartTime ? scope.row.activityStartTime.split(' ')[0] : '-' }}
                  至
                  {{ scope.row.activityEndTime ? scope.row.activityEndTime.split(' ')[0] : '-' }}
                </div>
              </div>
              <span class="icon-wenhao1 wenhao" v-if="scope.row.activityName"></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="totalIncomes" label="总服务费(元)" min-width="140px" width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.totalIncomes }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page"
        background
        layout="total,prev, pager, next"
        @current-change="getList"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
//当前实例组件
import activityTip from '@/components/activityTip'
import { pageTool } from "@/api/mixins";
import headBox from "@/components/head.vue";
import topSearchForm from "@/components/topSearchForm";
export default {
  mixins: [pageTool],
  components: { headBox, topSearchForm, activityTip },
  data: () => ({
    tableData: [],
    tableCurrent: 1,
    pagesize: 10,
    total: 0,
    searchParams: {
      createTime: [],
      mechanType: '1',
    },
    insureName: '',
    nameType: '1',
    totalData: {
      profitSum: '',
      totalIncomesSum: '',
      policyNum: '',
      feeSum: '',
      subIncomesSum: '',
    },
    loading: false,
    userinfo: {}
  }),
  created() {
    this.userinfo = this.$tools.getLocal("userinfo");
    this.all = this.$tools.getLocal('all')
    this.initListAjax('/master/policy/queryPolicyCommissons')
  },
  methods: {
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data) {
      let val = data.map((item) => {
        if (item.children.length == 0) {
          item.children = ''
        } else {
          this.handleDeptTree(item.children)
        }
        return item
      })
      return val
    },
    setListParams(params) {
      if (params.createTime && params.createTime.length == 2) {
        params.issueTimeStart = params.createTime[0]
        params.issueTimeEnd = params.createTime[1]
        delete params.createTime
      }
      if (params.nameType == '1') {
        params.policyerName = params.name
      } else if (params.nameType == '2') {
        params.insuranceName = params.name
      }
      delete params.nameType
      delete params.name

      params.policyerName = ''
      params.insuranceName = ''
      if (this.nameType == '1') {
        params.policyerName = this.insureName
      } else if (this.nameType == '2') {
        params.insuranceName = this.insureName
      }
      params.isQueryWaitValid = 1
    },
    exportOut: function () {
      const params = Object.assign({}, this.searchParams)
      this.setListParams(params)
      this.$tools.daochu(
        this.$config.api_root + '/master/policy/exportPolicyCommissons',
        params
      )
    },
    listCallback(res) {
      this.totalData = res.statistics || {}
    },
    getPayNum(num) {
      const map = {
        '1': '首年',
        '2': '第二年',
        '3': '第三年',
        '4': '第四年',
        '5': '第五年',
      }
      return map[num] || '-'
    },
  },
}
</script>
<style lang="scss" scoped>
@import './salesmanWaitSettlement';
</style>
